
(function() {
  'use strict';
  
  // Initialize when DOM is ready
  function init() {
    const searchCategory = document.getElementById('search-category');
    const searchInput = document.querySelector('.header__search .search__input');
    const searchForm = document.querySelector('.header__search form');
    const searchModal = document.querySelector('.header__search details');
    
    if (!searchCategory || !searchInput || !searchForm) {
      setTimeout(init, 100);
      return;
    }
    
    console.log('Search initialized');
    
    // Function to fetch and display blog posts
    function fetchBlogPosts(query = '*') {
      const resultsContainer = document.querySelector('.search-modal__results');
      if (!resultsContainer) return;
      
      resultsContainer.innerHTML = '<h3 class="search-modal__results-title">Available Blog Posts</h3><div class="predictive-search__loading-state">Loading posts...</div>';
      
      // Fetch blog posts using Shopify's search API
      fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=article&resources[limit]=20`)
        .then(response => response.json())
        .then(data => {
          console.log('Blog posts data:', data);
          
          if (data.resources && data.resources.results && data.resources.results.articles) {
            const articles = data.resources.results.articles;
            
            if (articles.length > 0) {
              let html = '<h3 class="search-modal__results-title">Blog Posts</h3>';
              html += '<div class="predictive-search__results-groups-wrapper">';
              html += '<ul class="predictive-search__results-list" role="listbox">';
              
              articles.forEach(article => {
                const imageUrl = article.image || '';
                const title = article.title || 'Untitled';
                const excerpt = article.body_safe ? article.body_safe.substring(0, 100) + '...' : '';
                const url = article.url || '#';
                
                html += `
                  <li class="predictive-search__list-item">
                    <a href="${url}" class="predictive-search__item" style="display: flex; gap: 12px; text-decoration: none; color: inherit; width: 100%;">
                      ${imageUrl ? `<img src="${imageUrl}" alt="${title}" class="predictive-search__item-image" style="width: 70px; height: 70px; object-fit: cover; border-radius: 8px; flex-shrink: 0;">` : '<div class="predictive-search__item-image" style="width: 70px; height: 70px; background: #f5f5f5; border-radius: 8px; flex-shrink: 0;"></div>'}
                      <div class="predictive-search__item-content" style="flex: 1;">
                        <h5 class="predictive-search__item-heading" style="font-size: 14px; font-weight: 500; margin: 0 0 6px 0;">${title}</h5>
                        ${excerpt ? `<p style="font-size: 13px; color: #666; margin: 0;">${excerpt}</p>` : ''}
                      </div>
                    </a>
                  </li>
                `;
              });
              
              html += '</ul></div>';
              resultsContainer.innerHTML = html;
            } else {
              resultsContainer.innerHTML = '<h3 class="search-modal__results-title">Blog Posts</h3><div class="predictive-search--no-results">No blog posts found.</div>';
            }
          } else {
            resultsContainer.innerHTML = '<h3 class="search-modal__results-title">Blog Posts</h3><div class="predictive-search--no-results">No blog posts available.</div>';
          }
        })
        .catch(error => {
          console.error('Error fetching blog posts:', error);
          resultsContainer.innerHTML = '<h3 class="search-modal__results-title">Blog Posts</h3><div class="predictive-search--no-results">Error loading blog posts.</div>';
        });
    }
    
    // Function to fetch and display all products
    function fetchAllProducts(query = '*') {
      const resultsContainer = document.querySelector('.search-modal__results');
      if (!resultsContainer) return;
      
      resultsContainer.innerHTML = '<h3 class="search-modal__results-title">Products</h3><div class="predictive-search__loading-state">Loading products...</div>';
      
      // Fetch products using Shopify's search API
      fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=20`)
        .then(response => response.json())
        .then(data => {
          console.log('Products data:', data);
          
          if (data.resources && data.resources.results && data.resources.results.products) {
            const products = data.resources.results.products;
            
            if (products.length > 0) {
              let html = '<h3 class="search-modal__results-title">Products</h3>';
              html += '<div class="predictive-search__results-groups-wrapper">';
              html += '<ul class="predictive-search__results-list" role="listbox">';
              
              products.forEach(product => {
                const imageUrl = product.image || '';
                const title = product.title || 'Untitled';
                const price = product.price ? `₹${(product.price / 100).toFixed(2)}` : '';
                const url = product.url || '#';
                
                html += `
                  <li class="predictive-search__list-item">
                    <a href="${url}" class="predictive-search__item" style="display: flex; gap: 12px; text-decoration: none; color: inherit; width: 100%;">
                      ${imageUrl ? `<img src="${imageUrl}" alt="${title}" class="predictive-search__item-image" style="width: 70px; height: 70px; object-fit: cover; border-radius: 8px; flex-shrink: 0;">` : '<div class="predictive-search__item-image" style="width: 70px; height: 70px; background: #f5f5f5; border-radius: 8px; flex-shrink: 0;"></div>'}
                      <div class="predictive-search__item-content" style="flex: 1;">
                        <h5 class="predictive-search__item-heading" style="font-size: 14px; font-weight: 500; margin: 0 0 6px 0;">${title}</h5>
                        ${price ? `<p class="predictive-search__item-price" style="font-size: 13px; color: #4a90e2; font-weight: 600; margin: 0;">${price}</p>` : ''}
                      </div>
                    </a>
                  </li>
                `;
              });
              
              html += '</ul></div>';
              resultsContainer.innerHTML = html;
            } else {
              resultsContainer.innerHTML = '<h3 class="search-modal__results-title">Products</h3><div class="predictive-search--no-results">No products found.</div>';
            }
          } else {
            resultsContainer.innerHTML = '<h3 class="search-modal__results-title">Products</h3><div class="predictive-search--no-results">No products available.</div>';
          }
        })
        .catch(error => {
          console.error('Error fetching products:', error);
          resultsContainer.innerHTML = '<h3 class="search-modal__results-title">Products</h3><div class="predictive-search--no-results">Error loading products.</div>';
        });
    }
    
    // Function to fetch and display collection products
    function fetchCollectionProducts(collectionHandle, query = '') {
      const resultsContainer = document.querySelector('.search-modal__results');
      if (!resultsContainer) return;
      
      resultsContainer.innerHTML = '<h3 class="search-modal__results-title">Collection Products</h3><div class="predictive-search__loading-state">Loading products...</div>';
      
      console.log('Fetching collection:', collectionHandle, 'with query:', query);
      
      // Fetch collection products directly from collection endpoint
      fetch(`/collections/${collectionHandle}/products.json?limit=50`)
        .then(response => response.json())
        .then(data => {
          console.log('Collection products data:', data);
          
          if (data.products && data.products.length > 0) {
            let products = data.products;
            
            // Filter by query if provided
            if (query && query.length > 0) {
              const lowerQuery = query.toLowerCase();
              products = products.filter(product => {
                const title = (product.title || '').toLowerCase();
                const tags = (product.tags || []).join(' ').toLowerCase();
                const type = (product.product_type || '').toLowerCase();
                return title.includes(lowerQuery) || tags.includes(lowerQuery) || type.includes(lowerQuery);
              });
            }
            
            if (products.length > 0) {
              let html = '<h3 class="search-modal__results-title">Collection Products</h3>';
              html += '<div class="predictive-search__results-groups-wrapper">';
              html += '<ul class="predictive-search__results-list" role="listbox">';
              
              // Limit to 20 results
              products.slice(0, 20).forEach(product => {
                const imageUrl = product.images && product.images[0] ? product.images[0].src : '';
                const title = product.title || 'Untitled';
                const price = product.variants && product.variants[0] && product.variants[0].price 
                  ? `₹${parseFloat(product.variants[0].price).toFixed(2)}` 
                  : '';
                const url = `/products/${product.handle}`;
                
                html += `
                  <li class="predictive-search__list-item">
                    <a href="${url}" class="predictive-search__item" style="display: flex; gap: 12px; text-decoration: none; color: inherit; width: 100%;">
                      ${imageUrl ? `<img src="${imageUrl}" alt="${title}" class="predictive-search__item-image" style="width: 70px; height: 70px; object-fit: cover; border-radius: 8px; flex-shrink: 0;">` : '<div class="predictive-search__item-image" style="width: 70px; height: 70px; background: #f5f5f5; border-radius: 8px; flex-shrink: 0;"></div>'}
                      <div class="predictive-search__item-content" style="flex: 1;">
                        <h5 class="predictive-search__item-heading" style="font-size: 14px; font-weight: 500; margin: 0 0 6px 0;">${title}</h5>
                        ${price ? `<p class="predictive-search__item-price" style="font-size: 13px; color: #4a90e2; font-weight: 600; margin: 0;">${price}</p>` : ''}
                      </div>
                    </a>
                  </li>
                `;
              });
              
              html += '</ul></div>';
              resultsContainer.innerHTML = html;
            } else {
              resultsContainer.innerHTML = '<h3 class="search-modal__results-title">Collection Products</h3><div class="predictive-search--no-results">No products found matching your search in this collection.</div>';
            }
          } else {
            resultsContainer.innerHTML = '<h3 class="search-modal__results-title">Collection Products</h3><div class="predictive-search--no-results">No products found in this collection.</div>';
          }
        })
        .catch(error => {
          console.error('Error fetching collection products:', error);
          resultsContainer.innerHTML = '<h3 class="search-modal__results-title">Collection Products</h3><div class="predictive-search--no-results">Error loading products. Please try again.</div>';
        });
    }
    
    // Handle category change
    searchCategory.addEventListener('change', function() {
      const selectedValue = this.value;
      console.log('Category changed:', selectedValue);
      
      // Remove existing filters
      let typeInput = searchForm.querySelector('input[name="type"]');
      let resourcesInput = searchForm.querySelector('input[name="resources[type]"]');
      
      if (typeInput) {
        typeInput.remove();
      }
      if (resourcesInput) {
        resourcesInput.remove();
      }
      
      // Clear collection filters from search input
      const currentQuery = searchInput.value.replace(/collection:\S+\s*/g, '').trim();
      
      if (selectedValue === 'product') {
        // Search all products
        typeInput = document.createElement('input');
        typeInput.type = 'hidden';
        typeInput.name = 'resources[type]';
        typeInput.value = 'product';
        searchForm.appendChild(typeInput);
        
        // Reset search input to original query without collection filter
        searchInput.value = currentQuery;
        
        // Fetch and display all products
        fetchAllProducts();
        
      } else if (selectedValue === 'article') {
        // Search blog posts/articles
        typeInput = document.createElement('input');
        typeInput.type = 'hidden';
        typeInput.name = 'resources[type]';
        typeInput.value = 'article';
        searchForm.appendChild(typeInput);
        
        // Reset search input to original query without collection filter
        searchInput.value = currentQuery;
        
        // Fetch and display blog posts
        fetchBlogPosts();
        
      } else if (selectedValue.startsWith('collection-')) {
        // Search products in specific collection
        const collectionHandle = selectedValue.replace('collection-', '');
        
        // Add product type filter
        typeInput = document.createElement('input');
        typeInput.type = 'hidden';
        typeInput.name = 'resources[type]';
        typeInput.value = 'product';
        searchForm.appendChild(typeInput);
        
        // Add collection constraint to the query
        searchInput.value = currentQuery ? `${currentQuery} collection:${collectionHandle}` : `collection:${collectionHandle}`;
        
        // Fetch and display collection products
        fetchCollectionProducts(collectionHandle);
        
      } else {
        // "All" selected - remove all filters
        searchInput.value = currentQuery;
        
        // Clear results
        const resultsContainer = document.querySelector('.search-modal__results');
        if (resultsContainer) {
          resultsContainer.innerHTML = '<h3 class="search-modal__results-title">Search results</h3><div class="predictive-search--no-results">Start typing to search...</div>';
        }
      }
      
      // Note: We don't trigger search events here anymore since we're fetching directly
    });
    
    // Handle search input for filtering based on selected category
    searchInput.addEventListener('input', function() {
      const selectedCategory = searchCategory.value;
      const query = this.value.trim();
      
      // Handle Posts (Articles) category
      if (selectedCategory === 'article') {
        if (query.length > 0) {
          // Search with query
          fetchBlogPosts(query);
        } else {
          // Show all posts when search is cleared
          fetchBlogPosts();
        }
      }
      
      // Handle Products category
      else if (selectedCategory === 'product') {
        if (query.length > 0) {
          // Search products with query
          fetchAllProducts(query);
        } else {
          // Show all products when search is cleared
          fetchAllProducts();
        }
      }
      
      // Handle Collection category
      else if (selectedCategory.startsWith('collection-')) {
        const collectionHandle = selectedCategory.replace('collection-', '');
        if (query.length > 0) {
          // Search collection products with query
          const cleanQuery = query.replace(/collection:\S+\s*/g, '').trim();
          fetchCollectionProducts(collectionHandle, cleanQuery);
        } else {
          // Show all collection products when search is cleared
          fetchCollectionProducts(collectionHandle);
        }
      }
      
      // For "All" category, let Shopify's default predictive search handle it
      // (This is handled by the predictive-search component)
    });
    
    
    
    // Prevent body scroll when modal is open
    if (searchModal) {
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.attributeName === 'open') {
            if (searchModal.hasAttribute('open')) {
              document.body.style.overflow = 'hidden';
              // Focus on input after animation
              setTimeout(function() {
                searchInput.focus();
              }, 350);
            } else {
              document.body.style.overflow = '';
            }
          }
        });
      });
      
      observer.observe(searchModal, {
        attributes: true
      });
    }
    
    // Mobile: Scroll input into view when focused
    if (window.innerWidth <= 749) {
      searchInput.addEventListener('focus', function() {
        setTimeout(function() {
          searchInput.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 300);
      });
    }
    
    // Handle window resize
    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        if (searchModal && searchModal.hasAttribute('open')) {
          const modalContent = document.querySelector('.search-modal__content');
          if (modalContent) {
            modalContent.style.height = window.innerHeight + 'px';
          }
        }
      }, 250);
    });
    
    // Close modal when clicking overlay
    const overlay = document.querySelector('.header__search .modal-overlay');
    if (overlay) {
      overlay.addEventListener('click', function() {
        if (searchModal) {
          searchModal.removeAttribute('open');
        }
      });
    }
  }
  
  // Start initialization
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
